<!-- Copyright (c) 2024 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="main"> 
    <div class="left-menu" ref="leftMenu">
      <Menus :menu="menu" @menuClicked="menuClicked" />
    </div>
    <div class="right-container">
      <TableBox :title="`${teamType} Team`" :tableData="salesServiceListing" :selectedRow.sync="selectedSalesServices" :loading="teamsListingLoading"/>
    </div>
    <PopupEntry :show.sync="showPopupEntry" v-if="showPopupEntry" :title="popupEntryTitle"
      :updatedBy="updatedBy" :createdBy="createdBy" @save="popupEntrySaveClicked"
      :requiredError="popupEntryRequiredError" @requiredClicked="requiredClicked" :successMessages="popupEntrySuccessMessages"
      :messages="popupEntryMessages" :errorMessages="popupEntryErrorMessages"
      :viewMode="viewMode" :cancelButton="viewMode ? 'Close' : 'Cancel'">
      <div>
        <Input :placeholder="`${teamType} Team Code`" :inputValue.sync="teamCodeInputValue" :isRequired="true" :isDisabled="viewModePK" :errorMessage.sync="teamCodeErr"
            ref="teamCodeErr" validator="text,10,uppercase"/>
        <Input :placeholder="`${teamType} Team Name`" :inputValue.sync="teamDescInputValue" :isRequired="true" :isDisabled="viewModePK" :errorMessage.sync="teamDescErr"
            ref="teamDescErr" validator="text,40,uppercase"/>
      </div>
      <!-- bottom section -->
      <div class="details-section">
        <div class="person-list">
          <div v-if="!viewMode" class="call-to-action-buttons">
            <button @click="addPersonClicked" ref="nonePersonErr">Add</button>
            <button @click="deletePersonClicked">Delete</button>
          </div>
          <div class="table-box-container">
            <TableBox :title="`${teamType} Persons`" :tableData="personTableDataWithoutDeleted" :selectedRow.sync="selectedPerson" :maxSelection="-1" 
            :hideColumns="[`${this.teamType}TeamCode`, '_action']"/>
          </div>
        </div>

        <div v-if="showEmployee" class="employee-list">
          <div class="call-to-action-buttons">
            <button style="margin-right: 5px;" @click="addEmployeeClicked">Add</button>
            <button @click="cancelEmployeeClicked">Cancel</button>
          </div>
          <div class="table-box-container">
            <TableBox title="Employees" :tableData="filterEmployeeListing" :selectedRow.sync="selectedEmployee" :maxSelection="-1"
            :hideColumns="['Updated on', 'Updated by']"/>
          </div>
        </div>
      </div>
    </PopupEntry>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
    },
  computed: {
    menu: function(){
      return [
        { title: `New ${this.teamType} Team`, icon: 'https://dsmlib.logistics.systems/Icons/icons8-add-new-50.png', enabled: true, key: 'mnuNew' },
        { title: `Edit ${this.teamType} Team`, icon: 'https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png', enabled: true, key: 'mnuEdit' },
        { title: `Delete ${this.teamType} Team` , icon: 'https://dsmlib.logistics.systems/Icons/icons8-reduce-50.png', enabled: true, key: 'mnuDelete' },
        { title: `View ${this.teamType} Team`, icon: 'https://dsmlib.logistics.systems/Icons/icons8-view-64.png', enabled: true, key: 'MnuView' }
      ]
    },
    personTableDataWithoutDeleted: function () {
      return this.personsTableData.filter((p) => p._action !== "D");
    },
     
    filterEmployeeListing: function() {
      let saved = [];
      this.personTableDataWithoutDeleted.forEach((p) => {
          if (p[`${this.teamType} Person Code`] && p[`${this.teamType} Person Code`] != '') {
            saved.push(p[`${this.teamType} Person Code`]);
          }
      });
      return this.employeeList.filter((e) => !(saved.includes(e['Employee ID'])));
    },
  },
  data: function() {
    return {
      //popup 
      popupEntryRequiredError: [],
      popupEntrySuccessMessages: [],
      popupEntryMessages: [],
      popupEntryErrorMessages: [],
      popupEntryTitle: "",
      showPopupEntry: false,
      showEmployee: false,
      teamsListingLoading: false,

      //common
      action: '', 
      createdBy:'',
      updatedBy: '',
      viewMode: false,
      viewModePK: false,
      teamType: '',

      teamCodeInputValue: '', 
      teamDescInputValue: '', 

      //listing
      selectedSalesServices: [],
      salesServiceListing: [],
      salesServiceDetails: [],
      personsTableData: [],
      employeeList: [],
      selectedPerson: [],
      selectedEmployee: [],
      //error
      teamCodeErr: '', 
      teamDescErr: '',
      personCodeErr: '',
    };
  },
  props: {
  },
  methods: {
    menuClicked: async function (e) {
      this.clearPopupEntryMessages();
      this.resetPopupEntryFields();

      switch (e.title) {
        case `New ${this.teamType} Team`:
          this.popupEntryTitle = `New ${this.teamType} Team`;
          this.viewMode = false;
          this.viewModePK = false;
          this.showPopupEntry = true;
          break;

        case `Edit ${this.teamType} Team`:
          if (this.selectedSalesServices.length == 0) {
            this.$showAlert('error', `No ${this.teamType} is selected`, `Please select a ${this.teamType} to edit`);
            break;
          }

          this.$fullscreenLoading(`Getting ${this.teamType} Team Details`);
          this.populatePopupEntryFields(
            (await this.getDetails(this.selectedSalesServices[0][`${this.teamType} Team Code`]))[this.teamType]
          );
          this.$fullscreenLoading();

          this.viewMode = false;
          this.viewModePK = true;
          this.showPopupEntry = true;
          this.popupEntryTitle = `Edit ${this.teamType} Team`;
          break;

        case `Delete ${this.teamType} Team`:
          if (this.selectedSalesServices.length == 0) {
            this.$showAlert('error', `Delete ${this.teamType} Team`, `Please select a ${this.teamType} to delete`);
            return;
          }

          this.$fullscreenLoading(`Getting ${this.teamType} Team Details`);
          this.populatePopupEntryFields(
            (await this.getDetails(this.selectedSalesServices[0][`${this.teamType} Team Code`]))[this.teamType]
          );
          this.$fullscreenLoading();

          let promptMessage = `Are you sure you want to delete this ${this.teamType} Team <b>${this.selectedSalesServices[0][`${this.teamType} Team Code`]}</b>?`;
          if (this.personsTableData.length > 0) {
            const personCount = this.personsTableData.length;
            promptMessage += `<br><br>This will also delete <b>${personCount} ${this.teamType} person${personCount > 1 ? "s" : ""}</b>`;
          }

          const deleteConfirmation = await this.$showAlert('warning', `Delete ${this.teamType} Team`, promptMessage, [
            { text: 'Delete', textColor: 'white', color: 'red' },
            { text: 'Cancel' },
          ]);
          if (deleteConfirmation == 'Cancel') {
            break;
          }

          this.$fullscreenLoading(`Deleting ${this.teamType} Team`);
          const result = await this.$apiCallV2('/SalesServices/SaveSalesService', this.formatSaveRequestBody("D"));
          this.$fullscreenLoading();

          if (result[0]['Results'] != '0') {
            this.$showAlert('error', `${this.teamType} Team NOT Deleted`, `There was an error deleting ${this.teamType} Team ${this.selectedSalesServices[0][`${this.teamType} Team Code`]}`);
            break;
          }

          // Delete successful
          this.$showAlert('success', `${this.teamType} Team Deleted`, `Successfully deleted ${this.teamType} Team ${this.selectedSalesServices[0][`${this.teamType} Team Code`]}`);
          this.selectedSalesServices = [];
          this.getListing();
          break;

        case `View ${this.teamType} Team`:
          if (this.selectedSalesServices.length == 0) {
            this.$showAlert('error', `No ${this.teamType} is selected`, `Please select a ${this.teamType} to view`);
            break;
          }

          this.$fullscreenLoading(`Getting ${this.teamType} Team Details`);
          this.populatePopupEntryFields(
            (await this.getDetails(this.selectedSalesServices[0][`${this.teamType} Team Code`]))[this.teamType]
          );
          this.$fullscreenLoading();

          this.popupEntryTitle = `View ${this.teamType} Team`;
          this.viewMode = true;
          this.viewModePK = true;
          this.showPopupEntry = true;
          break;
      }
    },
    clearPopupEntryMessages: function () {
      this.popupEntryRequiredError = [];
      this.popupEntrySuccessMessages = [];
      this.popupEntryMessages = [];
      this.popupEntryErrorMessages = [];
    },
    resetPopupEntryFields: function () { // clears off most fields, and set defaults for some
      // popup entry state
      this.popupEntryTitle = "";
      this.createdBy = '';
      this.updatedBy = '';
      this.showEmployee = false;

      this.teamCodeErr = "";
      this.teamDescErr = "";
      this.personCodeErr = "";

      this.teamCodeInputValue = "";
      this.teamDescInputValue = "";
      this.personsTableData = [];
      this.selectedPerson = [];
      this.selectedEmployee = [];
    },
    addPersonClicked: function (pointerEvent) {
      this.selectedEmployee = [];
      this.showEmployee = true;
    },
    cancelEmployeeClicked: function (pointerEvent) {
      this.showEmployee = false;
    },
    addEmployeeClicked: function (pointerEvent) {
      let modifiedPersonsTableData = [
        ...this.personsTableData.map((p) => {
          delete p._rowid;
          return p;
        })
      ];

      this.selectedEmployee.forEach(employee => {
        modifiedPersonsTableData.push({
          "#": (modifiedPersonsTableData.length + 1).toString(),  
          [`${this.teamType} Person Code`]: employee["Employee ID"] ?? "",
          [`${this.teamType} Person Name`]: employee["Employee Name"] ?? "",
          _action: "N"  
        });
      });
      this.personsTableData = [];
      this.selectedEmployee = [];  
      this.$nextTick(() => {
        this.personsTableData = modifiedPersonsTableData;
        this.showEmployee = false;
      });
    },
    deletePersonClicked: async function (pointerEvent) {
      if (this.selectedPerson.length === 0) {
        this.$showAlert("error", `No ${this.teamType} Person Selected`, "Please select at least one person to delete", [{ "text": "OK" }]);
        return;
      }

      const deleteConfirmation = await this.$showAlert(
        "warning", `Delete ${this.teamType} Person(s)`, "Are you sure you wish to delete the selected person(s)?",
        [{ "text": "Delete", "color": "Red", "textColor": "white" }, { "text": "Cancel" }]
      );
      if (deleteConfirmation === "Cancel") {
        return;
      }

      this.selectedPerson.forEach(person => {
        let matchedIndex = this.personsTableData.findIndex((p) =>
          p[`${this.teamType} Person Code`] === person[`${this.teamType} Person Code`]
        );

        if (matchedIndex === -1) {
          console.error(`${this.teamType} Person - Could not find the row being deleted`);
          return;
        }

        this.personsTableData.forEach((i) => {
          if (i['#'] > this.personsTableData[matchedIndex]['#']) {
            i['#'] = (parseInt(i['#']) - 1).toString();
          }
        });

        if (this.personsTableData[matchedIndex]._action === "N") {
          this.personsTableData.splice(matchedIndex, 1);
        } else {
          this.personsTableData[matchedIndex]._action = "D";
        }
      });

      const modifiedPersonsTableData = this.personsTableData;
      this.personsTableData = [];
      this.selectedPerson = [];
      this.$nextTick(() => {
        this.personsTableData = modifiedPersonsTableData;
        this.showEmployee = false;
      });
    },

    
    popupEntrySaveClicked: async function () {
      if (this.showEmployee) {
        const discardChanges = await this.promptDiscardPersonsChanges();
        if (discardChanges === "Cancel") {
          return;
        }
        this.showEmployee = false;
      }

      const isInvalid = this.checkPopupEntryFields();
      if (isInvalid) {
        return;
      }

      const action = this.popupEntryTitle[0];
      const requestBody = this.formatSaveRequestBody(action);
      
      this.$fullscreenLoading(`Saving ${this.teamType} Team`);
      const result = await this.$apiCallV2("/SalesServices/SaveSalesService", requestBody);
      this.$fullscreenLoading();

      // Save Error
          if (result[0]['Results'] != "0") {
        if (action == "N") {
          if(result[0]['Results'] == "1") {
          this.popupEntryErrorMessages.push(`There was an error creating ${this.teamType} Team: ${result[0]['ErrMsg']}`);
          } else if (result[0]['Results'] == "2"){
          this.popupEntryErrorMessages.push(`The following service persons are already assigned to another ${this.teamType} Team: ${result[0]['ErrMsg']}`);
          } 
        } else if (action == "E") {
          if(result[0]['Results'] == "1") {
          this.popupEntryErrorMessages.push(`There was an error editing ${this.teamType} Team: ${result[0]['ErrMsg']}`);
          } else if (result[0]['Results'] == "2"){
          this.popupEntryErrorMessages.push(`The following service persons are already assigned to another ${this.teamType} Team: ${result[0]['ErrMsg']}`);
          } 
        }
        return;
      }

      // Save Success
      this.viewMode = true;
      this.viewModePK = true;
      this.showEmployee = false;
      this.popupEntryTitle = `View ${this.teamType} Team`;
      this.getListing();
      if (action == "N") {
        this.popupEntrySuccessMessages.push(`Successfully created ${this.teamType} Team: ${result[0]['Team Code']}`);
      } else {
        this.popupEntrySuccessMessages.push(`Successfully edited ${this.teamType} Team: ${result[0]['Team Code']}`);
      }
    },
    formatSaveRequestBody: function (action){
      let requestBody = {
        'action': action,
        'teamcode': this.teamCodeInputValue.trim(),
        'teamdesc': this.teamDescInputValue,
        'teamtype': this.teamType,
      } 

      if (action === "D") {
        return requestBody;
      }

      let personsArr = [];
      for (const personsData of this.personsTableData) {
        if (!personsData._action) {
          continue;
        }

        personsArr.push({
          "subaction": personsData._action,
          "personcode": personsData[`${this.teamType} Person Code`],
          "personname": personsData[`${this.teamType} Person Name`],
        })
      }
      requestBody.persons = personsArr;
      return requestBody;
    },
    promptDiscardPersonsChanges: function () {
      return this.$showAlert(
        "warning", "Discard Changes",
        `You have unsaved changes.<br>Do you wish to discard the changes?`,
        [{ "text": "Discard", "color": "Red", "textColor": "white" }, { "text": "Cancel" }]
      );
    },
    checkPopupEntryFields: function(){
      let error = false;
      
      this.clearPopupEntryMessages();

      if(this.teamCodeInputValue.trim() === ""){
        this.teamCodeErr = `${this.teamType} Code is required!`;
        this.popupEntryRequiredError.push({key: 'teamCodeErr', value: this.teamCodeErr});
        error = true;
      } else if(this.teamCodeInputValue.length > 10){
        this.teamCodeErr = `${this.teamType} Code cannot exceed 10 characters!`;
        this.popupEntryRequiredError.push({key: 'teamCodeErr', value: this.teamCodeErr});
        error = true;
      }

      if(this.teamDescInputValue.trim() === ""){
        this.teamDescErr = `${this.teamType} Description is required!`;
        this.popupEntryRequiredError.push({key: 'teamDescErr', value: this.teamDescErr});
        error = true;
      }else if(this.teamDescInputValue.length > 40){
        this.teamDescErr = `${this.teamType} Description cannot exceed 40 characters!`;
        this.popupEntryRequiredError.push({key: 'teamDescErr', value: this.teamDescErr});
        error = true;
      }
       if (this.personsTableData.filter(p => p._action !== "D").length === 0) {
        this.popupEntryRequiredError.push({ key: 'nonePersonErr', value: `Please add at least one ${this.teamType} Person.` });
        error = true;
      }

      return error;
    },
    populatePopupEntryFields: function (salesServiceDetails){
      // popup entry state
      this.createdBy = `${salesServiceDetails['User Created']?.trim() ?? ''} ${salesServiceDetails['Created On'] ? new Date(salesServiceDetails['Created On']).formatString("dd/MM/yyyy HH:mm") : ''}`;
      this.updatedBy = `${salesServiceDetails['User ID']?.trim() ?? ''} ${salesServiceDetails['Date Updated'] ? new Date(salesServiceDetails['Date Updated']).formatString("dd/MM/yyyy HH:mm") : ''}`;

      // common fields
      this.teamCodeInputValue = this.populateTextTrim(salesServiceDetails[`${this.teamType}TeamCode`]);
      this.teamDescInputValue = this.populateTextTrim(salesServiceDetails[`${this.teamType}TeamDesc`]);
      this.personsTableData = salesServiceDetails[`${this.teamType}Details`];
    },
    getDetails: async function (code){
      if(this.teamType === "Service"){
        return (await this.$apiCallV2(`/Master/GetDetailsMaster`, { "masterfile": "SERVICE", "recordid": code }));
      }else{
        return (await this.$apiCallV2(`/Master/GetDetailsMaster`, { "masterfile": "SALES", "recordid": code }));
      }
    }, 
    routeChanged: async function(to) {      
      // determine the team type based on the route path
      // checkTeamType split the path and get the last element using checkTeamType function
      this.teamType = this.checkTeamType(to ? to.path : this.$route.path);
      await this.getListing();
    },
    getListing: async function(to) {
      this.salesServiceListing = [];
      this.teamsListingLoading = true;
      this.$fullscreenLoading(`Getting ${this.teamType} ...`);
      
      // fetch the sales service listing based on the team type
      if (this.teamType === "Service") {
        this.salesServiceListing = await this.$apiCallV2(`/Master/GetListMaster`, { masterfile: 'SERVICETEAM', module: 'MASTER' });
      } else if (this.teamType === "Sales") {
        this.salesServiceListing = await this.$apiCallV2(`/Master/GetListMaster`, { masterfile: 'SALESTEAM', module: 'MASTER' });
      }
      
      this.$fullscreenLoading();
      this.teamsListingLoading = false;
    },
    //get team type
    checkTeamType: function(routePath){
      const path = routePath.split('/').pop();
      return path.includes("Sales") ? "Sales" : "Service";
    },
    requiredClicked: async function(item) {
      if(item === 'nonePersonErr'){
        this.$nextTick(()=>{
          this.addPersonClicked();
        })
      }else{
        this.$nextTick(() => {
          this.$refs[item].setFocus();
        });
      }
    },
    populateTextTrim: function (text) { // To populate text with trim
      return text ? text.trim() : '';
    },
  },
  async mounted() {
    this.employeeList = await this.$apiCallV2(`/Master/GetListMaster`, { masterfile: 'EMPLOYEE', module: 'MASTER'});
    await this.routeChanged();
  },
  watch: {
    async $route() {
      await this.routeChanged();
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.main {
  display: flex;
  font-size: 12px;
  padding: 10px 45px;

  > .left-menu {
      display: flex;
      justify-content: center;
    }

    > .right-container {
    width: 100%;
    margin-left: 5px;
    padding: 5px;
    background-color: white;
    border-radius: 5px;
    display: flex;
    overflow: hidden;
  }

  .details-section{
    display: flex;
    flex-direction: row;
    overflow-y: scroll;
    width: 100%;
    overflow-x: hidden;
    margin-top: 5px;
    height: 100%;

    .call-to-action-buttons {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      margin: 5px;
  
      >button:nth-child(1) {
        margin-right: 5px;
      }
    }

    .table-box-container{
      height:calc(100% - 40px);
      width: 100%;
      padding: 5px;
      background-color: white;
      border-radius: 5px;
      display: flex;
      overflow: hidden;
    }

    .person-list{
      width: 100%;
    }

    .employee-list {
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 75%;
      margin-left: 3px;
    }
  }
}

</style>